export default {
  'CLICK-BTN-INDPACK-REPACK': {
    key: 'click-btn-indPack-repack',
    label: '点击-独立打包-重新打包'
  },
  'SCAN-INPUT-INDPACK-SCANTOBEPACKAGEDORDER': {
    key: 'scan-input-indPack-scanToBePackagedOrder',
    label: '扫描-独立打包-待打包订单号-触发'
  },
  'SCAN-INPUT-INDPACK-SCANGOODSBARCODE': {
    key: 'scan-input-indPack-scanGoodsBarcode',
    label: '扫描-独立打包-商品条码-触发'
  },
  'CLICK-BTN-INDPACK-FULLPACKAGE': {
    key: 'click-btn-indPack-fullPackage',
    label: '点击-独立打包-满包裹'
  },
  'CLICK-BTN-INDPACK-CONFIRMINPUTPACKAGECOUNT': {
    key: 'click-btn-indPack-confirmInputPackageCount',
    label: '点击-独立打包-输入包裹数量确认-触发'
  }
}